import { fromExistingCodeDataList } from './ExistingCodeData.js';
import { requireObject } from './parse.js';

/**
 * Mirrors com.medprompt.patient.data.PatientCodesData (Jackson Set<ExistingCode> as arrays)
 *
 * @typedef {object} PatientCodesData
 * @property {import('./ExistingCodeData.js').ExistingCodeData[]} activeCodes
 * @property {import('./ExistingCodeData.js').ExistingCodeData[]} significantPastCodes
 */

/**
 * @param {object} raw
 * @returns {PatientCodesData}
 */
export function fromPatientCodesData(raw) {
  const source = requireObject(raw, 'PatientCodesData');
  return {
    activeCodes: fromExistingCodeDataList(source.activeCodes),
    significantPastCodes: fromExistingCodeDataList(source.significantPastCodes),
  };
}
